import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIList from 'UIComponents/list/UIList';
import TrackRender from 'growth-payments-core/usage-tracker/TrackRender';
import { events } from 'growth-payments-core/usage-tracker/events';
import { TrackedButton } from 'growth-payments-core/usage-tracker/components/Button';
import { useCallback, useEffect } from 'react';
import { Metrics } from '../../utils/metrics';
import CelebrationModal from './CelebrationModal';
import { useQueryStringState } from 'growth-payments-core/query-string/useQueryStringState';
import { EnrollmentFlowType } from '../../types';
import { markSetUpPaymentsComplete } from '../../utils/tasks';
import { navigateToWithQueryParams } from 'growth-payments-core/urls/utils';
import { getCommerceHomeUrl } from 'growth-payments-core/urls/urls';
import { getFullUrl } from 'hubspot-url-utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const TEST_IDS = {
  KYC_SUCCESS_MODAL_VERIFY: 'kyc-success-modal-verify'
};
const StripeApplicationSuccessModal = ({
  businessTypeDetails,
  onClose,
  shouldReloadOnEnrollmentComplete = true
}) => {
  const {
    businessType,
    businessStructure
  } = businessTypeDetails;
  const [__, setCurrentEnrollmentFlow] = useQueryStringState('paymentsEnrollment', EnrollmentFlowType.processorPicker);
  const handleClick = useCallback(() => {
    setCurrentEnrollmentFlow(undefined);
    if (shouldReloadOnEnrollmentComplete) {
      const fullUrl = getFullUrl('app');
      const commerceHomeUrlWithKycParam = new URL(`${fullUrl}${getCommerceHomeUrl()}`);
      commerceHomeUrlWithKycParam.searchParams.set('kycSubmitted', 'true');
      navigateToWithQueryParams(commerceHomeUrlWithKycParam.toString());
    } else {
      markSetUpPaymentsComplete().catch(() => {});
      onClose();
    }
  }, [setCurrentEnrollmentFlow, shouldReloadOnEnrollmentComplete, onClose]);
  useEffect(() => {
    if (businessType) {
      Metrics.counter('stripe-success-modal-viewed', {
        businessType,
        businessStructure: businessStructure || ''
      }).increment();
    }
  }, [businessStructure, businessType]);
  const renderCta = () => {
    return /*#__PURE__*/_jsx(TrackedButton, {
      event: events.paymentSettingsInteraction,
      trackingProperties: {
        action: 'stripeApplicationSuccessModalButtonClicked'
      },
      "data-test-id": TEST_IDS.KYC_SUCCESS_MODAL_VERIFY,
      use: "secondary",
      onClick: handleClick,
      children: shouldReloadOnEnrollmentComplete ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "stripeSubmissionSuccessModal.primaryCta"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "stripeSubmissionSuccessModal.continue"
      })
    });
  };
  return /*#__PURE__*/_jsx(CelebrationModal, {
    title: "stripeSubmissionSuccessModal.header",
    testID: "kyc-success-modal",
    bodyContent: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(TrackRender, {
        event: events.growthPaymentsPageView,
        properties: {
          screen: 'stripe-application-success-modal'
        }
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        style: {
          textAlign: 'left',
          paddingLeft: '20px'
        },
        children: /*#__PURE__*/_jsxs(UIList, {
          styled: true,
          children: [/*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "stripeSubmissionSuccessModal.body1"
            })
          }), /*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "stripeSubmissionSuccessModal.body2"
            })
          }), /*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "stripeSubmissionSuccessModal.body3"
            })
          })]
        })
      })]
    }),
    onClose: handleClick,
    CTA: renderCta()
  });
};
export default StripeApplicationSuccessModal;